import { useTranslate } from "@similarweb/i18n-provider";
import { Info24px } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { SliderFixedValues, Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

type Props = {
    totalKeywords: number;
    value: number;
    ticks: number[];
    onChange: (value: number) => void;
    isDisabled?: boolean;
    isFetching?: boolean;
};

export const KeywordsSlider = ({
    totalKeywords,
    value,
    ticks,
    onChange,
    isDisabled = false,
    isFetching = false,
}: Props) => {
    const { translate } = useTranslate();

    return (
        <SliderFixedValues
            dataAutomation="keywords-slider-input"
            disabled={isDisabled || ticks.length === 0}
            title={
                <Flex
                    alignItems="center"
                    gap="2px"
                >
                    <Text fontVariant="body2">{translate("rankTracker.gsc.keywordsSlider.label")}</Text>
                    <Tooltip content={translate("rankTracker.gsc.keywordsSlider.info")}>
                        <Info24px
                            color={colorsPalettes.carbon[200]}
                            size="sm"
                        />
                    </Tooltip>
                </Flex>
            }
            description={
                <Flex gap="3px">
                    <Text fontVariant="body2">{isFetching ? "—" : value}</Text>
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon[300]}
                    >
                        / {isFetching ? "—" : totalKeywords}
                    </Text>
                </Flex>
            }
            fixedValues={ticks}
            value={value}
            onChange={onChange}
        />
    );
};
